// @ts-check
// This file is part of ecbyts/ECBT (Environmental & Occupational Core Byte Tools).
// Copyright (C) 2026 Calvin Stefan Iost
// Licensed under the GNU Affero General Public License v3.0 (AGPL-3.0-only).

export interface HudRefreshPlan {
    /** true: calcular e pintar agora. false: repintar do cache e tentar de novo. */
    readonly renderNow: boolean;
    /** Quando tentar de novo (ms). 0 quando renderNow. */
    readonly retryInMs: number;
}

const AGORA: HudRefreshPlan = Object.freeze({ renderNow: true, retryInMs: 0 });

/**
 * Throttle das cards da #geo-hud com atualização FINAL garantida (Calvin 2026-09-16,
 * pontos cegos da HUD). CUSTOS e ECBT (1,2 s) e COMPLIANCE (1,5 s) repintavam do cache
 * dentro da janela e não agendavam nada: uma mudança que chegasse no meio da janela
 * ficava fora da tela até a PRÓXIMA atualização alheia — que podia nunca vir.
 *
 * Regra: fora da janela (ou sem render anterior) calcula agora; dentro da janela
 * devolve quanto falta para ela fechar, e quem chama agenda UMA nova tentativa.
 * Relógio que andou para trás conta como fora da janela: travar a card é pior do que
 * calcular de novo.
 */
export function planHudRefresh(nowMs: number, lastRenderMs: number, intervalMs: number): HudRefreshPlan {
    const now = Number(nowMs);
    const last = Number(lastRenderMs);
    const interval = Math.max(0, Number(intervalMs) || 0);
    if (!Number.isFinite(now) || !Number.isFinite(last) || last <= 0) return AGORA;
    const elapsed = now - last;
    if (elapsed < 0 || elapsed >= interval) return AGORA;
    return Object.freeze({ renderNow: false, retryInMs: Math.max(1, Math.ceil(interval - elapsed)) });
}
